import React from 'react'
import { FormattedMessage } from 'react-intl'

import { TREATMENT_OPTIONS } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/treatmentOptions'
import { TREATMENT_RECOMMENDATION_TIER } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/treatmentRecommendationsConstants'
import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

import { openUrl } from '../utils/expo-linking'

export const uphs: GetCustomerCopyFunc = () => {
  const pennMedicineEAPUrl = 'https://www.med.upenn.edu/PennMedicineEAP/'
  const pennPsychiatryUrl = 'https://www.pennmedicine.org/services/mental-behavioral-health/psychiatry'
  const pennMedicineEAPConfiguration = {
    title: (
      <FormattedMessage
        defaultMessage='Penn Medicine EAP'
        description='Title for Penn Medicine EAP when shown as a treatment recommendation'
      />
    ),
    description: (
      <FormattedMessage
        defaultMessage='Access the Penn Medicine EAP for up to 8 free, confidential counseling sessions per topic, plus financial guidance and legal support, available 24/7 for you and your household.'
        description='Description for Penn Medicine EAP'
      />
    ),
    modalDescription: (
      <FormattedMessage
        defaultMessage='With the Penn Medicine EAP, you get 24/7 access to up to 8 free, confidential counseling sessions per topic to help you and your household navigate life’s challenges. You can also connect with experts for unlimited financial guidance and discounted legal support to manage your overall wellbeing.{lineBreak}{lineBreak}Learn more about the services available through Penn Medicine EAP.'
        description='Custom modal description for Penn Medicine EAP'
        values={{
          lineBreak: '\n',
        }}
      />
    ),
    buttonText: (
      <FormattedMessage
        defaultMessage='Book appointment'
        description='Button text to book appointment at Penn Medicine EAP'
      />
    ),
    url: pennMedicineEAPUrl,
  }

  const pennPsychiatryConfiguration = {
    title: (
      <FormattedMessage
        defaultMessage='Penn Psychiatry'
        description='Title for Penn Psychiatry when shown as a treatment recommendation'
      />
    ),
    description: (
      <FormattedMessage
        defaultMessage='Access comprehensive inpatient and outpatient psychiatric care through the Penn Medicine Department of Psychiatry.'
        description='Description for Penn Psychiatry'
      />
    ),
    modalDescription: (
      <FormattedMessage
        defaultMessage='The Penn Medicine Department of Psychiatry provides a full spectrum of mental health services, ranging from hospital-based treatment to community outpatient programs. Their team utilizes research-based therapies and advanced interventional services to create personalized recovery plans for every individual.{lineBreak}{lineBreak}Learn more about the services available through Penn Psychiatry.'
        description='Modal description for Penn Psychiatry'
        values={{
          lineBreak: '\n',
        }}
      />
    ),
    buttonText: (
      <FormattedMessage
        defaultMessage='Book appointment'
        description='Button text to book appointment at Penn Psychiatry'
      />
    ),
    url: pennPsychiatryUrl,
  }

  return {
    customForkedTriageOptions: [
      { label: 'Penn Medicine EAP', onPress: () => openUrl(pennMedicineEAPUrl), minAge: 18 },
      { label: 'Penn Psychiatry', onPress: () => openUrl(pennPsychiatryUrl), minAge: 18 },
    ],
    // NOTE: optionRanking indices represent insertion positions in a progressively shifting array.
    // Sequential splice operations shift subsequent indices - e.g., after inserting at index 2,
    // the next insertion at index 3 will appear at the original position 2 (adjacent to the first).
    // The order of items in this array determines their display order when they share the same ranking.
    treatmentOptions: [
      {
        option: TREATMENT_OPTIONS.ONSITE_THERAPY,
        config: { customCopy: pennMedicineEAPConfiguration, actingSearcherMinAge: 18 },
        optionRanking: {
          [TREATMENT_RECOMMENDATION_TIER.TIER_2]: 2,
          [TREATMENT_RECOMMENDATION_TIER.TIER_3]: 2,
        },
      },
      {
        option: TREATMENT_OPTIONS.CUSTOMER_PROVIDED_PROGRAM,
        config: { customCopy: pennPsychiatryConfiguration, actingSearcherMinAge: 18 },
        optionRanking: {
          [TREATMENT_RECOMMENDATION_TIER.TIER_2]: 3,
          [TREATMENT_RECOMMENDATION_TIER.TIER_3]: 3,
        },
      },
    ],
  }
}
